// @flow
import React from 'react'
import I18n from 'i18n-react'
import Select from 'react-select/lib/Select'
import classNames from 'classnames'

import { RadioTile } from '../../../Components/'
import StringEnumRef from './StringEnumRef'

// types
import type { ResourcesType } from '../../Types/Resources'
import type { DefaultFormFieldState, DefaultFormFieldType } from './AbstractFormField'

type TilesWithSelectProps = DefaultFormFieldType & {
  domain: {
    _type: string,
    values: Array<string>,
    resourceName: string,
  },
  options: any,
  resources: ResourcesType,
  value: {
    [key: string]: string
  }
}

type SelectedValue = {
  [key: string]: string
}

type TilesWithSelectState = DefaultFormFieldState & {
  options?: Array<SelectedValue>,
  prevPropsValue: string,
  parentName: string,
  showSelect: boolean,
}

export default class TilesWithSelect extends StringEnumRef<TilesWithSelectProps, TilesWithSelectState> {
  constructor(props: TilesWithSelectProps) {
    super(props)
    this.state = {
      options: [],
      prevPropsValue: '',
      pristine: true,
      value: null,
      showSelect: false,
    }
    this.selectRef = React.createRef()
  }

  componentDidMount() {
    if (this.props.value && !this.props.valueNames[this.props.value]) {
      this.setState({ showSelect: true })
    }
  }

  handleOnChange = (value: string) => {
    if (value) {
      this.setState({ value })
      this.props.onChange(value.value)
    } else {
      this.setState({ value: {} })
      this.props.onChange('')
    }
  }

  handleOnChangeTile = (value: string) => {
    if (value !== 'other') {
      this.props.onChange(value)
      if (this.props.valueNames[value]) {
        this.setState({ showSelect: false })
      }
    } else {
      this.setState({ showSelect: true })
    }
  }

  handleOnBlur = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.onBlur()
    if (event.target.value) {
      this.selectRef.current.selectFocusedOption()
    }
  }

  render() {
    const { id, prefix, textMode, value, name, enabled, valueNames, icons } = this.props
    const { labels, showSelect } = this.state

    if (textMode) {
      let label = value
      if (labels && labels[value]) {
        label = labels[value]
      }
      return <span>{label}</span>
    }

    const classes = ['row']
    if (this.hasErrors() && !this.isPristine()) {
      classes.push('is-invalid')
    }

    let tileValues = []
    let tileOptions = []
    if (valueNames) {
      tileOptions = Object.keys(valueNames).map((tileValue) => {
        tileValues.push(tileValue)
        return ({
          value: tileValue,
          label: valueNames[tileValue]
        })
      })
    }
    let options = [
      ...tileOptions,
      ...this.state.options.filter(option => !tileValues.includes(option.value))
    ]

    return (
      <div className={classNames(classes)}>
        <div className='col-12'>
          <div className='row d-none d-md-flex'>
            {valueNames && Object.keys(valueNames).map((tileValue) => (
              <RadioTile
                checked={value === tileValue || tileValue === 'other' && showSelect}
                icon={icons ? icons[tileValue] : ''}
                id={`${prefix}-${id}-${tileValue}`}
                key={`${id}-${tileValue}`}
                label={valueNames[tileValue]}
                name={`${prefix}${name}`}
                onChange={this.handleOnChangeTile}
                readOnly={!enabled}
                value={tileValue}
              />
            ))}
          </div>
          {showSelect &&
          <div className='react-select'>
            <Select
              clearAllText={I18n.translate('stringEnum.clearAllText')}
              clearValueText={I18n.translate('stringEnum.clearValueText')}
              clearable={false}
              disabled={!enabled}
              name={name}
              noResultsText={I18n.translate('stringEnum.noResultsText')}
              onBlur={this.handleOnBlur}
              onChange={this.handleOnChange}
              options={options}
              placeholder={I18n.translate(`select.${name}.placeholder`, {notFound: I18n.translate('stringEnum.placeholder')})}
              ref={this.selectRef}
              searchPromptText={I18n.translate('stringEnum.searchPromptText')}
              value={value}
            />
          </div>
          }
          {this.renderError()}
        </div>
      </div>
    )
  }
}
